import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

var PageBreak = function PageBreak(_ref) {
  var text = _ref.text,
      color = _ref.color,
      fontSize = _ref.fontSize,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("page-break", className),
    style: {
      color: color,
      fontSize: fontSize
    }
  }, text);
};

PageBreak.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  fontSize: PropTypes.number,
  className: PropTypes.string
};
export default PageBreak;